import { FaroText, grey } from "@faro-lotv/flat-ui";
import { ButtonBase, alpha } from "@mui/material";
import { type JSX } from "react";
import { HOVER_OPACITY } from "./calendar/calendar-styles";
import { formatDate } from "./capture-date-format";

type RangeEndpointButtonProps = {
  /** Placeholder shown while the endpoint is unset */
  label: string;
  /** The endpoint's current date */
  date?: Date;
  /** True while the next calendar click replaces this endpoint's value */
  isEditing: boolean;
  /** Make this the endpoint the next click moves */
  onClick(): void;
};

/** @returns One end of the range in the popup heading, dimmed while it awaits a new value */
export function RangeEndpointButton({
  label,
  date,
  isEditing,
  onClick,
}: RangeEndpointButtonProps): JSX.Element {
  return (
    <ButtonBase
      aria-label={`edit range ${label.toLowerCase()}`}
      aria-pressed={isEditing}
      onClick={onClick}
      sx={{
        px: 0.5,
        borderRadius: "4px",
        "&:hover": { backgroundColor: alpha(grey[500], HOVER_OPACITY) },
      }}
    >
      <FaroText
        variant="heading20"
        color={isEditing ? grey[0] : grey[500]}
        sx={{ whiteSpace: "nowrap" }}
      >
        {date ? formatDate(date) : label}
      </FaroText>
    </ButtonBase>
  );
}
